import { getHoverColor } from "./utils";

/**
 * Color exports using css variables when we cannot directly use the chakra theme
 * Often used for charts and other visualizations
 */
export const CHART_COLORS = {
  text: "var(--chakra-colors-text-tertiary)",
  gray: {
    border: "var(--chakra-colors-base-border)",
    divider: "var(--chakra-colors-base-divider)",
    text: "var(--chakra-colors-text-primary)",
    cursor: "var(--chakra-colors-gray-900)",
    base: "var(--chakra-colors-gray-400)",
    baseHover: getHoverColor({ color: "var(--chakra-colors-gray-base)" }),
  },
  green: {
    light: "var(--chakra-colors-charts-green-light)",
    base: "var(--chakra-colors-charts-green-base)",
    baseHover: getHoverColor({
      color: "var(--chakra-colors-charts-green-base)",
    }),
  },
  purple: {
    light: "var(--chakra-colors-charts-purple-light)",
    base: "var(--chakra-colors-charts-purple-base)",
    baseHover: getHoverColor({
      color: "var(--chakra-colors-charts-purple-base)",
    }),
  },
  blue: {
    light: "var(--chakra-colors-charts-blue-light)",
    base: "var(--chakra-colors-charts-blue-base)",
    baseHover: getHoverColor({
      color: "var(--chakra-colors-charts-blue-base)",
    }),
  },
  pink: {
    light: "var(--chakra-colors-charts-pink-light)",
    base: "var(--chakra-colors-charts-pink-base)",
    baseHover: getHoverColor({
      color: "var(--chakra-colors-charts-pink-base)",
    }),
  },
  yellow: {
    light: "var(--chakra-colors-charts-yellow-light)",
    base: "var(--chakra-colors-charts-yellow-base)",
    baseHover: getHoverColor({
      color: "var(--chakra-colors-charts-yellow-base)",
    }),
  },
  orange: {
    light: "var(--chakra-colors-charts-orange-light)",
    base: "var(--chakra-colors-charts-orange-base)",
    baseHover: getHoverColor({
      color: "var(--chakra-colors-charts-orange-base)",
    }),
  },
  brown: {
    light: "var(--chakra-colors-charts-brown-light)",
    base: "var(--chakra-colors-charts-brown-base)",
    baseHover: getHoverColor({
      color: "var(--chakra-colors-charts-brown-base)",
    }),
  },
  red: {
    light: "var(--chakra-colors-charts-red-light)",
    base: "var(--chakra-colors-charts-red-base)",
    baseHover: getHoverColor({
      color: "var(--chakra-colors-charts-red-base)",
    }),
  },
};
